import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { EditableCell } from '@app/components/tables/editableTable/EditableCell';
import { Form, Typography, Popconfirm, Space, Row, Col, Table, Modal } from 'antd';
import { useState, useEffect, useContext } from 'react';
import { PricingOptionsContext } from './ProductPricingForm';
import { CrudSettingsContext } from '@app/contexts/CrudSettingsContext';
import { ExclamationCircleFilled } from '@ant-design/icons';
const { confirm } = Modal;

type Item = {
  key: string;
  strategy: string;
  qty?: number;
  min_qty_inclusive?: number;
  max_qty_exclusive?: number;
  percentage?: number;
  price: number;
};

export const PricingOptionsTable: React.FC<{ mode: string }> = ({ mode }) => {
  const [form] = Form.useForm();
  const [editingKey, setEditingKey] = useState('');
  const [openModel1, setOpenModel1] = useState(false);
  const [openModel2, setOpenModel2] = useState(false);

  const context = useContext(PricingOptionsContext);

  const PR = context.selectedPricingStrategy == 'PR';
  const PP = context.selectedPricingStrategy == 'PP';
  const PQ = context.selectedPricingStrategy == 'PQ';
  const FR = context.selectedPricingStrategy == 'FR';
  const QB = context.selectedPricingStrategy == 'QB';

  const isEditing = (record: Item) => record.key === editingKey;

  const create = () => {
    console.log(context.selectedPricingStrategy);

    if (context.selectedPricingStrategy == '' || context.selectedPricingStrategy == undefined) {
      setOpenModel1(true);
    } else if (context.selectedPricingStrategy != '' || context.selectedPricingStrategy != undefined) {
      form.resetFields();
      const newKey = context?.pricingOptions?.length.toString();

      const moreThanOneQBOption = context.pricingOptions.filter((e) => e.strategy == 'QB').length >= 1;
      const moreThanOneFROption = context.pricingOptions.filter((e) => e.strategy == 'FR').length >= 1;

      if (moreThanOneFROption && FR) {
        setOpenModel2(true);
      } else if (moreThanOneQBOption && QB) {
        setOpenModel2(true);
      } else {
        const record: any = {
          PP: {
            key: newKey,
            strategy: context.selectedPricingStrategy,
            price: 0,
            percentage: 0,
          },
          PQ: {
            key: newKey,
            strategy: context.selectedPricingStrategy,
            price: 0,
            qty: 0,
          },
          PR: {
            key: newKey,
            strategy: context.selectedPricingStrategy,
            price: 0,
            min_qty_inclusive: 0,
            max_qty_exclusive: 0,
          },
          FR: {
            key: newKey,
            strategy: context.selectedPricingStrategy,
            price: 0,
          },
          QB: {
            key: newKey,
            strategy: context.selectedPricingStrategy,
            price: 0,
          },
        };

        context.setPricingOptions([...context.pricingOptions, record[context.selectedPricingStrategy]]);
        console.log(record);
        console.log(context.selectedPricingStrategy);
        console.log(newKey);
        setEditingKey(newKey);
      }
    }
  };

  const edit = (record: Partial<Item> & { key: React.Key }) => {
    form.setFieldsValue({ ...record });
    setEditingKey(record.key);
  };

  const remove = (record: Partial<Item> & { key: React.Key }) => {
    const newOptions = [...context.pricingOptions.filter((e) => e != record)];
    context?.setPricingOptions(newOptions);
  };

  const cancel = () => {
    setEditingKey('');
  };

  const save = async (key: React.Key) => {
    try {
      const row = (await form.validateFields()) as Item;

      const newOptions = [...context.pricingOptions];
      const index = newOptions.findIndex((item) => key === item.key);
      if (index > -1) {
        const item = newOptions[index];
        newOptions.splice(index, 1, {
          ...item,
          ...row,
        });
        context.setPricingOptions(newOptions);
        context?.setPricingOptions(newOptions);
        setEditingKey('');
      } else {
        newOptions.push(row);
        context.setPricingOptions(newOptions);
        context?.setPricingOptions(newOptions);
        setEditingKey('');
      }
    } catch (errInfo) {
      console.log('Validate Failed:', errInfo);
    }
  };

  const columns = [
    {
      title: 'Pricing Strategy',
      dataIndex: 'strategy',
    },
    {
      title: 'Percentage (%)',
      dataIndex: 'percentage',
      // width: '25%',
      editable: PP && true,
    },
    {
      title: 'Quantity',
      dataIndex: 'qty',
      // width: '25%',
      editable: PQ && true,
    },
    {
      title: 'Min. Quantity (Inclusive)',
      dataIndex: 'min_qty_inclusive',
      // width: '25%',
      editable: PR && true,
    },
    {
      title: 'Max. Quantity (Exclusive)',
      dataIndex: 'max_qty_exclusive',
      // width: '25%',
      editable: PR && true,
    },
    {
      title: 'Price (LKR)',
      dataIndex: 'price',
      editable: true,
    },
    {
      title: 'Action',
      dataIndex: 'action',
      render: (_: any, record: Item) => {
        const editable = isEditing(record);
        console.log(context.selectedPricingStrategy);
        return editable ? (
          <Space wrap>
            <Typography.Link onClick={() => save(record.key)} style={{ marginRight: 8 }}>
              Save
            </Typography.Link>
            <Popconfirm title="Sure to cancel?" onConfirm={cancel}>
              <a>Cancel</a>
            </Popconfirm>
          </Space>
        ) : (
          <Space wrap>
            <Typography.Link disabled={editingKey !== ''} onClick={() => edit(record)}>
              Edit
            </Typography.Link>

            <Popconfirm title="Sure to delete?" onConfirm={() => remove(record)}>
              <Typography.Link disabled={editingKey !== ''}>Delete</Typography.Link>
            </Popconfirm>
          </Space>
        );
      },
    },
  ];

  const mergedColumns = columns?.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record: Item) => ({
        record,
        inputType: col.dataIndex == 'max_qty_exclusive' ? 'text' : 'number',
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  const getColumns = () => {
    if (mode == 'view') {
      mergedColumns.pop();
    }

    return mergedColumns;
  };

  return (
    <>
      <Row gutter={[16, 16]} justify={'end'}>
        {mode != 'view' && (
          <Col>
            <Space>
              <BaseButton htmlType="button" type="primary" size="middle" onClick={create}>
                Add
              </BaseButton>
              <Modal title="Pricing strategy is required!" open={openModel1} onOk={() => setOpenModel1(false)}>
                <p>Please select a pricing strategy to proceed to add pricing options.</p>
              </Modal>
              <Modal title="Only one pricing option allowed!" open={openModel2} onOk={() => setOpenModel2(false)}>
                <p>A Flat Rate or Quantity Based pricing strategy can only have one pricing option!</p>
              </Modal>
            </Space>
          </Col>
        )}

        <Col span={24}>
          <Form form={form} component={false}>
            <Table
              title={() => 'Price List'}
              components={{
                body: {
                  cell: EditableCell,
                },
              }}
              rowKey="id"
              size="small"
              scroll={{ x: true }}
              bordered
              dataSource={context.pricingOptions}
              columns={getColumns()}
              rowClassName="editable-row"
              pagination={false}
            />
          </Form>
        </Col>
      </Row>
    </>
  );
};
